export const chatLinks = [
  { title: "Ready to deepen your faith?", url: "/chat?category=faith", disabled: false, category: "faith" },
  { title: "Feeling anxious or depressed?", url: "/chat?category=emotions", disabled: false, category: undefined },
  { title: "Are you a teen?", url: "/chat?category=teen", disabled: false, category: "teen" },
  {
    title: "Want a free personality test?", url: "https://mindbalance.net/assessment/self", disabled: false, target: "_blank", category: undefined,
    children: [
      { url: "/assessment", title: "Free Personality Test" },
      { url: "/assessment/friends-family", title: "Email Family/Friends" },
      { url: "/assessment/summary", title: "Summary" },
      { url: "/assessment/reports", title: "Reports" }
    ]
  },
  { title: "Craving tips for entrepreneurs?", url: "chat?category=entrepreneurs", disabled: false, category: "entrepreneurs" },
  { title: "Need a spark of inspiration?", url: "/chat?category=quotes", disabled: false, category: "quotes" },
  { title: "Planning a trip?", url: "chat?category=travel", disabled: false, category: "travel" },
  { title: "Seeking  something else?", url: "/chat?exclude=true", disabled: false, category: "" },
];